/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fuzzy_Yummy_Mammoth_NailInputs */

const fr_fuzzy_yummy_mammoth_nail = /** @type {(inputs: Fuzzy_Yummy_Mammoth_NailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showcase`)
};

/**

* @param {Fuzzy_Yummy_Mammoth_NailInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fuzzy_yummy_mammoth_nail = /** @type {((inputs?: Fuzzy_Yummy_Mammoth_NailInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fuzzy_Yummy_Mammoth_NailInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fuzzy_yummy_mammoth_nail(inputs)
});